import { productService } from '../../services'

// initial state
const state = () => ({
  products: [],
  product: null,
  status: {},
})

// actions
const actions = {
  getProducts({ commit }) {
    commit('waitResponse');
    productService.getProducts()
      .then(
        products => {
          commit('productsSuccess', products);
        },
        error => {
          commit('productsFailure', error);
        }
      );
  },
  getProduct({ commit }, productId) {
    productService.getProduct(productId)
      .then(
        product => {
          commit('productSuccess', product);
        },
        error => {
          commit('productFailure', error);
        }
      );
  },
  syncProducts({ commit }) {
    commit('waitResponse');
    productService.syncProducts()
      .then(
        products => {
          commit('productsSuccess', products);
        },
        error => {
          commit('productsFailure', error);
        }
      );
  },
}

// mutations
const mutations = {
  waitResponse(state) {
    state.status = { isWaiting: true };
  },
  productsSuccess(state, products) {
    state.products = products;
    state.status = {};
  },
  productsFailure(state, error) {
    console.log(state, error);
    state.status = {};
  },
  productSuccess(state, product) {
    state.product = product;
    state.status = {};
  },
  productFailure(state, error) {
    console.log(state, error);
    state.status = {};
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
